// @ is an alias to /src
import mastertime from '@/api/mastertime'

export const namespaced = true

export const state = {
  roles: [],
  customerAdminRoles: [],
}

export const mutations = {
  setRoles(state, roles) {
    state.roles = roles
  },

  setCustomerAdminRoles(state, customerAdminRoles) {
    state.customerAdminRoles = customerAdminRoles
  },
}

export const actions = {
  async fetchRoles({ commit }, roleType) {
    const { data } = await mastertime.fetchRoles(roleType)
    const roles = data.data

    commit('setRoles', roles)
  },

  async fetchCustomerAdminRoles({ commit }, payload) {
    const { data } = await mastertime.fetchCustomerAdminRoles(payload)
    const customerAdminRoles = data.data

    commit('setCustomerAdminRoles', customerAdminRoles)
  },
}
